import React from "react";
import {
  SubTitleTab,
  TitleTab,
} from "../../../../../../component/page-components";
import { Col, Input, Row } from "antd";
import onKeyPressNumber from "../../../../../../util/onKeyPressNumber";

const OrderSpekOutsource = ({ FormInput, handleFormInput, err, error }) => {
  return (
    <div className="columns">
      <TitleTab title="Vehicle Specification" />
      <Row>
        <Col span={12} className="pr-2 ">
          <div className="container-field">
            <SubTitleTab title="Min Unit" />
            <Input
              size="large"
              placeholder="Type Min Unit"
              addonAfter="Pcs"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "min_order_unit");
              }}
              value={FormInput?.min_order_unit}
              status={error?.min_order_unit ? "error" : null}
            />
            <div className="text-red-100">
              {err ? err : error?.min_order_unit}
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div className="container-field">
            <SubTitleTab title="Max Unit" />
            <Input
              size="large"
              placeholder="Type Max Unit"
              addonAfter="Pcs"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "max_order_unit");
              }}
              value={FormInput?.max_order_unit}
              status={error?.max_order_unit ? "error" : null}
            />
            <div className="text-red-100">
              {err ? err : error?.max_order_unit}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={12} className="pr-2 ">
          <div className="container-field">
            <SubTitleTab title="Min Weight" />
            <Input
              size="large"
              placeholder="Type Min Weight"
              addonAfter="Kg"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "min_order_weight");
              }}
              value={FormInput?.min_order_weight}
              status={error?.min_order_weight ? "error" : null}
            />
            <div className="text-red-100">
              {err ? err : error?.min_order_weight}
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div className='container-field'>
            <SubTitleTab title="Max Weight" />
            <Input
              size="large"
              placeholder="Type Max Weight"
              addonAfter="Kg"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "max_order_weight");
              }}
              value={FormInput?.max_order_weight}
              status={error?.max_order_weight ? "error" : null}
            />
            <div className="text-red-100">
              {err ? err : error?.max_order_weight}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={12} className="pr-2 ">
          <div className='container-field'>
            <SubTitleTab title="Min Volume" />
            <Input
              size="large"
              placeholder="Type Min Volume"
              addonAfter="m3"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "min_order_volume");
              }}
              value={FormInput?.min_order_volume}
              status={error?.min_order_volume ? "error" : null}
            />
            <div className="text-red-100">
              {err ? err : error?.min_order_volume}
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div className="container-field">
            <SubTitleTab title="Max Volume" />
            <Input
              size="large"
              placeholder="Type Max Volume"
              addonAfter="m3"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "max_order_volume");
              }}
              value={FormInput?.max_order_volume}
              status={error?.max_order_volume ? "error" : null}
            />
            <div className="text-red-100">
              {err ? err : error?.max_order_volume}
            </div>
          </div>
        </Col>
      </Row>

      <div className="container-field">
        <SubTitleTab title="Fix Cost" />
        <Input
          addonBefore="IDR"
          size="large"
          placeholder="Type Fix Cost"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "fixed_cost");
          }}
          value={FormInput?.fixed_cost}
          status={error?.fixed_cost ? "error" : null}
        />
        <div className="text-red-100">{err ? err : error?.fixed_cost}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Variable Cost Per Km (Optional)" />
        <Input
          addonBefore="IDR"
          size="large"
          placeholder="Type Variable Cost Per Km"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "variable_cost");
          }}
          value={FormInput?.variable_cost}
          status={error?.variable_cost ? "error" : null}
        />
        <div className="text-red-100">{err ? err : error?.variable_cost}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Transporter Time Cost (Optional)" />
        <Input
          addonBefore="IDR"
          size="large"
          placeholder="Type Transporter Time Cost"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "transporter_time_cost");
          }}
          value={FormInput?.transporter_time_cost}
          status={error?.transporter_time_cost ? "error" : null}
          formatter
        />
        <div className="text-red-100">
          {err ? err : error?.transporter_time_cost}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Waiting Time Cost (Optional)" />
        <Input
          addonBefore="IDR"
          size="large"
          placeholder="Type Waiting Time Cost"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "waiting_time_cost");
          }}
          value={FormInput?.waiting_time_cost}
          status={error?.waiting_time_cost ? "error" : null}
        />
        <div className="text-red-100">{err ? err : error?.waiting_time_cost}</div>
      </div>
    </div>
  );
};

export default OrderSpekOutsource;
